// * RTK Query keepUnusedDataFor values (seconds).
// * Use these on every endpoint to keep cache behaviour consistent and tunable.

export const CACHE = {
  SHORT: 10 * 60, // * 10 min — frequently changing data (detections, usage)
  MEDIUM: 30 * 60, // * 30 min — semi-stable data (api keys)
  LONG: 60 * 60, // * 1 hr  — rarely changing data (user profile)
  XLONG: 2 * 60 * 60, // * 2 hr  — very stable data (plans, config)
} as const;
